import { render, staticRenderFns } from "./KnInstitutionalInfo.vue?vue&type=template&id=02284a8b"
import script from "./KnInstitutionalInfo.vue?vue&type=script&lang=js"
export * from "./KnInstitutionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports